module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 120.c56e7e3e.png";